import { useNavigate } from 'react-router-dom'
import { Machine } from '../../../utils/models/Machine'
import './MachineCard.scss'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../utils/redux/userSlice'
import { Spinner } from 'react-bootstrap'
import LastStatusInfo from '../../LastStatusComponent/LastStatusInfo/LastStatusInfo.component'
import { MachineConected } from 'aw-consts'
import DataCircle from '../../DataComponent/DataCircle.component'
import { getRandomNumber } from 'aw-generic-functions'

const MachineCard = (props: { machine: Machine, refresh: boolean }) => {

    const user = useSelector(selectUser)
    const navigate = useNavigate()
    const { t } = useTranslation()

    const onClickMachine = () => {
        navigate(`/userMachines?idmachine=${props.machine.idmachine}`)
    }

    
    return (
        <>
            <div className='kpiContainer px-2 rounded-1 d-flex flex-column w-100 h-100' onClick={onClickMachine}>
                <span className="mt-1 h4 text-center">{props.machine.name}</span>
                <LastStatusInfo _id={props.machine.idmachine} token={user.token} refresh={props.refresh} isMachineConnected={MachineConected.Conected} />
                {props.refresh ? <div className="text-center pt-4"><Spinner animation="border" style={{ color: 'var(--accent-color)' }} /></div> : 
                <>
                
                        <div className='row my-2 gx-0 flex-grow-1'>
                            <div className='col-4 p-1 d-flex align-items-stretch'>
                                <DataCircle color={3} data={getRandomNumber(15, 30)} refresh={props.refresh} title={`${t(`Measure`)} 1`} units={'ºC'} />
                            </div>
                            <div className='col-4 p-1 d-flex align-items-stretch'>
                                <DataCircle color={3} data={getRandomNumber(15, 30)} refresh={props.refresh} title={`${t(`Measure`)} 2`} units={'ºC'} />
                            </div>
                            <div className='col-4 p-1 d-flex align-items-stretch'>
                                <DataCircle color={3} data={getRandomNumber(100, 1000)} refresh={props.refresh} title={`${t(`Measure`)} 3`} units={''} />
                            </div>
                        </div>
                        <div className='row my-2 gx-0 flex-grow-1'>
                            <div className='col-4 p-1 d-flex align-items-stretch'>
                                <DataCircle color={3} data={getRandomNumber(100, 1000)} refresh={props.refresh} title={`${t(`Measure`)} 4`} units={''} />
                            </div>
                            <div className='col-4 p-1 d-flex align-items-stretch'>
                                <DataCircle color={3} data={getRandomNumber(15, 100)} refresh={props.refresh} title={`${t(`Measure`)} 5`} units={'%'} />
                            </div>
                            <div className='col-4 p-1 d-flex align-items-stretch'>
                                <DataCircle color={3} data={getRandomNumber(10, 100)} refresh={props.refresh} title={`${t(`Measure`)} 6`} units={'%'} />
                            </div>
                        </div>
                    </>
                    
                }
            </div >
        </>
    )
}

export default MachineCard